import React from "react";

import { Props } from "./types";

function BinIcon({ className }: Props) {
  return (
    <svg className={className} viewBox="0 0 14.952 18.402">
      <path
        d="M61.514,2.3H58.351V1.725A1.725,1.725,0,0,0,56.626,0h-2.3A1.725,1.725,0,0,0,52.6,1.725V2.3H49.438A1.438,1.438,0,0,0,48,3.738v1.15a.575.575,0,0,0,.575.575h13.8a.575.575,0,0,0,.575-.575V3.738A1.438,1.438,0,0,0,61.514,2.3Zm-7.763-.575a.576.576,0,0,1,.575-.575h2.3a.576.576,0,0,1,.575.575V2.3h-3.45Z"
        transform="translate(-48)"
      />
      <path
        d="M73.544,184a.18.18,0,0,0-.18.188l.474,9.958a1.723,1.723,0,0,0,1.723,1.643H84.3a1.723,1.723,0,0,0,1.723-1.643l.474-9.958a.18.18,0,0,0-.179-.188Zm8.685,1.438a.575.575,0,1,1,1.15,0v7.476a.575.575,0,0,1-1.15,0Zm-2.875,0a.575.575,0,1,1,1.15,0v7.476a.575.575,0,0,1-1.15,0Zm-2.875,0a.575.575,0,1,1,1.15,0v7.476a.575.575,0,0,1-1.15,0Z"
        transform="translate(-72.453 -177.387)"
      />
    </svg>
  );
}

export { BinIcon };
